import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getSingleAiChatAllMessages } from "../../features/aiControl/aiControlSlice"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;

    .username{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
    }

    .message{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);

    }

`

const AiMobilePastMessageItemContainer = ({item}) => {

    const dispatch = useDispatch()

  return (
    <Container onClick={() => {dispatch(getSingleAiChatAllMessages(item)) ; dispatch(showModal("aiMobileSingleChatDetails"))}}>
        <div className="username">{item.adSoyadUnvan}</div>
        <p className="message">{item.message}</p>
    </Container>
  )
}

export default AiMobilePastMessageItemContainer